import React from 'react';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faXmark, faDollarSign
} from '@fortawesome/free-solid-svg-icons';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';

const Container = styled(View)`
  margin-horizontal: 4px;
  flex-direction: row;
  align-items: center;
`;

const Header = styled(Text)`
  font-weight: 800;
  margin-right: 20px;
`;

const Label = styled(Text)`
  margin-right: 16px;
  margin-left: 6px;
`;

const BidFunctionsLegend = () => {
  return (
    <Container>
      <Header>Bid Functions Legend</Header>
      <FontAwesomeIcon
        icon={faCheck}
        color="green"
        size="lg"
        title="Accept"
      />
      <Label>Accept Bid (a confirmation will display)</Label>
      <FontAwesomeIcon
        icon={faXmark}
        color="red"
        size="lg"
        title="Reject"
      />
      <Label>Reject Bid (a confirmation will display)</Label>
      <FontAwesomeIcon
        icon={faDollarSign}
        color="black"
        size="lg"
        title="Counter"
      />
      <Label>Enter a Counter Offer</Label>
      <FontAwesomeIcon
        icon={faClockRotateLeft}
        color="black"
        size="lg"
        title="Bid History"
      />
      <Label>View Bid History</Label>
    </Container>
  );
};

export default BidFunctionsLegend;
